import React from "react";

const RegistrationPageContext = React.createContext();

export default RegistrationPageContext;
